<template>
  <div>
    <li id="uploadDocumentation">
      <fieldset>
        <legend>
          <span class="h3">Upload your supporting documents</span>
          <div class="status info">
            <p>Supported file types: PDF, JPEG, TIFF or PNG. </p>
            <p>The maximum file size is 20 MB. </p>
            <p>Do not use special characters in file names, such as apostrophes and accents.</p>
          </div>
        </legend>

        <ul class="questions">
          <li>
            <fieldset>
            <legend>
              <abbr
                class="required consent-abbr"
                id="label-info-consent"
                title="(required)"
                >*
             </abbr>
              <span class="h4 label">Attach supporting documents</span>
              <small class="hint">Upload up to {{ max }} supporting document files for example, proof of ID documents.</small>
            </legend>
              <table id="supportingDocumentationFiles" class="stretchWidth">
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="index in uploads.supportingFiles" :key="index" :id="'supportingDocumentationRow'+index" >
                    <td>
                      <label :for="'supportingDocumentation'+index"></label>
                      <input :id="'supportingDocumentation'+index" 
                        @change="handleUpload"
                        type="file" 
                        :name="'supportingDocumentation'+index" 
                        :accept="uploads.acceptedTypes">
                    </td>
                    <td class="fileProgress">
                    </td>
                    <td v-if="uploadExists('supportingDocumentation'+index)" class="fileOptions">
                      <div class="removeUpload" @click="removeUpload" :targetUpload="'supportingDocumentation'+index">x</div>
                    </td>
                    <td v-else>
                    </td>
                  </tr>
                </tbody>
              </table>
            </fieldset>
          </li>
        </ul>
      </fieldset>
    </li>
    <li id="uploading">
      <p v-if="uploads.uploading > 0">Uploading your attachment... ({{ uploads.uploading }} remaining)</p><p v-else></p>
      <div id="upload-warning" style="display: none" class="status warn">
          <p>Supporting documents must be uploaded for online submissions</p>
      </div>
    </li>
  </div>
</template>

<script> 
  import sppapi from '@/sppapi.js';
  export default {
    props: {
      value: Object,
      max: Number,
    },
    computed: {
      uploads: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    },
    methods: {
      removeUpload: function(event) {
        event.preventDefault()
        let targetUploadId = event.target.attributes['targetUpload'].value
        document.getElementById(targetUploadId).value = ''
        this.uploads.uploadIds = this.uploads.uploadIds.filter(uploadId => uploadId.fieldId !== targetUploadId)
        this.uploads.supportingFiles--;
        return false
      },
      uploadExists: function(fieldId) {
        return this.uploads.uploadIds.filter(uploadId => uploadId.fieldId == fieldId).length
      },
      handleUpload: function(event) {
        const selection = event.target.files[0]
        const ext = selection.name.split('.').pop();
        if (this.uploads.acceptedTypes.indexOf(ext) < 0) {
          document.getElementById(event.target.id).value = ''
          return
        }

        this.uploads.uploading++
        const reader = new FileReader()
        reader.onload = (e) => {
          sppapi.uploadFile(this, selection.name, event.srcElement.name, e.target.result)
          if (this.uploads.supportingFiles < this.max) {
            this.uploads.supportingFiles++
          }
        }
        reader.readAsDataURL(selection)
      },
    }
  }
</script>

<style>
#supportingDocumentationFiles td {
  padding: 0 0 1.2em 0;
  background: white;
}

#supportingDocumentationFiles th {
  display: none;
}

.removeUpload {
  cursor: pointer;
}
</style>